import { initialState } from './';

export default {
  update(context, value) {
    if (value) value.timeout = value.timeout || 3000;
    context.commit('SET_SNACKBAR', value ? value : initialState);
  }
};
